<template>
  <WrappedForm
    v-if="show"
    ref="form"
    class="job-application-config"
    label-width="200px"
    :model="stepData"
    :formLines="formLines"
    :disabled="disabled"
  >
    <template #resumeTypeRadio="{label, option}">
      <span>{{ label }}</span>
      <el-tooltip placement="top">
        <template #content>
          <div class="resume-type-tip-container">
            <div class="tip-title">{{ option.tipMessage.title }}</div>
            <ul v-if="option.tipMessage.contentList" class="tip-content-list">
              <li v-for="(item, index) in option.tipMessage.contentList" class="tip-content-item" :key="index">{{ item }}</li>
            </ul>
            <div v-if="option.tipMessage.mark" class="tip-mark">{{ option.tipMessage.mark }}</div>
          </div>
        </template>
        <span class="tip-icon">
          <i class="el-icon-question"></i>
        </span>
      </el-tooltip>
    </template>
    <template #assessment="{ line: { assessmentStatus } }">
      <div v-if="stepData.enableAssessment" class="assessment-detail">
        <el-checkbox
          v-if="!assessmentStatus.valuesAssessment.hidden"
          v-model="stepData.valuesAssessment"
          class="assessment-checkbox"
          :disabled="assessmentStatus.valuesAssessment.disabled"
          @change="handleAssessmentStatusChange"
        >
          <span>{{ $t(`${i18nPrefix}.label.valuesAssessment`) }}</span>
          <el-tooltip placement="top" :content="$t(`${i18nPrefix}.message.assessmentTip.valuesAssessment`)">
            <span class="tip-icon">
              <i class="el-icon-question"></i>
            </span>
          </el-tooltip>
        </el-checkbox>
        <el-checkbox
          v-if="!assessmentStatus.personalityAssessment.hidden"
          v-model="stepData.personalityAssessment"
          class="assessment-checkbox"
          :disabled="assessmentStatus.personalityAssessment.disabled"
          @change="handleAssessmentStatusChange"
        >
          <span>{{ $t(`${i18nPrefix}.label.personalityAssessment`) }}</span>
          <el-tooltip placement="top" :content="$t(`${i18nPrefix}.message.assessmentTip.personalityAssessment`)">
            <span class="tip-icon">
              <i class="el-icon-question"></i>
            </span>
          </el-tooltip>
        </el-checkbox>
        <el-checkbox
          v-if="!assessmentStatus.problemSolutionAssessment.hidden"
          v-model="stepData.problemSolutionAssessment"
          class="assessment-checkbox"
          :disabled="assessmentStatus.problemSolutionAssessment.disabled"
        >
          <span>{{ $t(`${i18nPrefix}.label.problemSolutionAssessment`) }}</span>
          <el-tooltip placement="top" :content="$t(`${i18nPrefix}.message.assessmentTip.problemSolutionAssessment`)">
            <span class="tip-icon">
              <i class="el-icon-question"></i>
            </span>
          </el-tooltip>
        </el-checkbox>
        <el-checkbox
          v-if="!assessmentStatus.careerPreferenceAssessment.hidden"
          v-model="stepData.careerPreferenceAssessment"
          class="assessment-checkbox"
          :disabled="assessmentStatus.careerPreferenceAssessment.disabled"
        >
          <span>{{ $t(`${i18nPrefix}.label.careerPreferenceAssessment`) }}</span>
          <el-tooltip placement="top" :content="$t(`${i18nPrefix}.message.assessmentTip.careerPreferenceAssessment`)">
            <span class="tip-icon">
              <i class="el-icon-question"></i>
            </span>
          </el-tooltip>
        </el-checkbox>
      </div>
    </template>
  </WrappedForm>
</template>

<script>
import mixin from './mixin'
import _ from 'lodash'
import { RESUME_TYPE, ASSESSMENT_TYPE } from '@/constant/job'

export default {
  mixins: [mixin],
  components: {

  },
  data () {
    return {
      RESUME_TYPE
    }
  },
  computed: {
    formLines () {
      const vm = this
      const isTemplate = this.isTemplate
      const isEditMode = this.isEditMode
      const requiredMessage = this.$t('common.message.requiredFormField')
      const requiredRule = [{ required: true, message: requiredMessage, trigger: 'blur' }]
      const trueFalseRadioOptionList = [{ label: this.$t('common.label.yes'), value: true }, { label: this.$t('common.label.no'), value: false }]
      const lines = {
        resumeType: {
          elType: 'el-radio-group',
          class: 'resume-type',
          label: this.$t(`${this.i18nPrefix}.label.resumeType`),
          option: {
            data: _.map(RESUME_TYPE, (resumeType, typeName) => {
              return {
                typeName: typeName,
                label: this.$t(`${this.i18nPrefix}.resumeType.${typeName}`),
                value: resumeType,
                tipMessage: this.$t(`${this.i18nPrefix}.message.resumeTypeTip.${typeName}`)
              }
            }),
            slotName: 'resumeTypeRadio'
          },
          rules: requiredRule
        },
        requiredResumeAttachment: {
          elType: 'el-checkbox',
          class: 'required-resume-attachment',
          label: '',
          checkboxLabel: this.$t(`${this.i18nPrefix}.message.requiredResumeAttachment`)
        },
        enableAssessment: {
          hidden: false,
          disabled: false,
          elType: 'el-radio-group',
          class: 'enable-radio',
          label: this.$t(`${this.i18nPrefix}.label.enableAssessment`),
          option: { data: trueFalseRadioOptionList },
          contentExtraSlot: 'assessment',
          assessmentStatus: {
            valuesAssessment: { hidden: false, get disabled () { return lines.enableAssessment.disabled } },
            personalityAssessment: { hidden: false, get disabled () { return lines.enableAssessment.disabled } },
            problemSolutionAssessment: { hidden: false, get disabled () { return lines.enableAssessment.disabled } },
            careerPreferenceAssessment: {
              hidden: false,
              get disabled () {
                const stepData = vm.stepData
                return !stepData.valuesAssessment || !stepData.personalityAssessment || lines.enableAssessment.disabled
              }
            }
          },
          rules: requiredRule
        },
        valuesAssessment: {
          elType: 'el-radio-group',
          class: 'enable-radio',
          label: this.$t(`${this.i18nPrefix}.label.valuesAssessment`),
          option: { data: trueFalseRadioOptionList },
          rules: requiredRule
        },
        assessmentType: {
          elType: 'el-radio-group',
          class: 'enable-radio',
          label: this.$t(`${this.i18nPrefix}.label.assessmentType`),
          option: {
            data: _.map(ASSESSMENT_TYPE, (value, typeName) => {
              return { typeName, value, label: this.$t(`${this.i18nPrefix}.assessmentType.${typeName}`) }
            })
          },
          rules: requiredRule
        },
        problemSolutionAssessment: {
          elType: 'el-radio-group',
          class: 'enable-radio',
          label: this.$t(`${this.i18nPrefix}.label.problemSolutionAssessment`),
          option: { data: trueFalseRadioOptionList }
        },
        candidateApplySatisfactionSurvey: {
          elType: 'el-radio-group',
          class: 'enable-radio',
          label: this.$t(`${this.i18nPrefix}.label.candidateApplySatisfactionSurvey`),
          option: { data: trueFalseRadioOptionList }
        },
        candidateInterviewSatisfactionSurvey: {
          elType: 'el-radio-group',
          class: 'enable-radio',
          label: this.$t(`${this.i18nPrefix}.label.candidateInterviewSatisfactionSurvey`),
          option: { data: trueFalseRadioOptionList }
        },
        hmInterviewSatisfactionSurvey: {
          elType: 'el-radio-group',
          class: 'enable-radio',
          label: this.$t(`${this.i18nPrefix}.label.hmInterviewSatisfactionSurvey`),
          option: { data: trueFalseRadioOptionList }
        },
        hmGradeSatisfactionSurvey: {
          elType: 'el-radio-group',
          class: 'enable-radio',
          label: this.$t(`${this.i18nPrefix}.label.hmGradeSatisfactionSurvey`),
          option: { data: trueFalseRadioOptionList }
        },
        canReapplyDays: {
          label: this.$t(`${this.i18nPrefix}.label.canReapplyDays`),
          placeholder: this.$t(`${this.i18nPrefix}.placeholder.canReapplyDays`)
        }
      }
      const canCustomAssessment = this.canCustomAssessment
      const hasAssessmentPermission = this.hasAssessmentPermission
      const hasCreateJobPermission = this.hasCreateJobPermission
      const hasCreateJobFromTemplatePermission = this.hasCreateJobFromTemplatePermission
      const hasReapplyPermission = this.hasReapplyPermission
      const hasSatisfactionSurveyPermission = this.hasSatisfactionSurveyPermission
      const hasSatisfactionSurveyHMPermission = this.hasSatisfactionSurveyHMPermission
      const hasHMInterviewPermission = this.hasHMInterviewPermission
      const hasHMRatingPermission = this.hasHMRatingPermission
      const hasSatisfactionSurveyCandidatePermission = this.hasSatisfactionSurveyCandidatePermission
      const hiddenList = []
      const disabledList = []

      if (canCustomAssessment) {
        hiddenList.push(lines.valuesAssessment, lines.assessmentType, lines.problemSolutionAssessment)
        if (!hasAssessmentPermission) {
          hiddenList.push(lines.enableAssessment)
        }
      } else {
        hiddenList.push(lines.enableAssessment)
        if (!hasAssessmentPermission) {
          hiddenList.push(lines.assessmentType, lines.valuesAssessment, lines.problemSolutionAssessment)
        } else {
          Object.defineProperty(lines.assessmentType, 'hidden', {
            configurable: true,
            enumerable: true,
            get () {
              return !vm.stepData.valuesAssessment
            }
          })
        }
      }
      if (!hasSatisfactionSurveyPermission) {
        hiddenList.push(lines.candidateApplySatisfactionSurvey, lines.candidateInterviewSatisfactionSurvey, lines.hmInterviewSatisfactionSurvey, lines.hmGradeSatisfactionSurvey)
      } else {
        if (!hasSatisfactionSurveyHMPermission) {
          hiddenList.push(lines.hmInterviewSatisfactionSurvey, lines.hmGradeSatisfactionSurvey)
        }

        if (!hasSatisfactionSurveyCandidatePermission) {
          hiddenList.push(lines.candidateApplySatisfactionSurvey, lines.candidateInterviewSatisfactionSurvey)
        }
      }
      if (!hasHMInterviewPermission) {
        hiddenList.push(lines.hmInterviewSatisfactionSurvey, lines.candidateInterviewSatisfactionSurvey)
      }
      if (!hasHMRatingPermission) {
        hiddenList.push(lines.hmGradeSatisfactionSurvey)
      }
      if (isTemplate) {
        hiddenList.push(lines.canReapplyDays)
        _.forEach([
          lines.resumeType,
          lines.enableAssessment,
          lines.valuesAssessment,
          lines.assessmentType,
          lines.problemSolutionAssessment
        ], line => {
          Object.defineProperty(line, 'rules', {
            configurable: true,
            enumerable: true,
            get () {
              return vm.stepData.isEditableTemplate ? null : requiredRule
            }
          })
        })
      } else {
        if (hasCreateJobFromTemplatePermission && !hasCreateJobPermission) {
          disabledList.push(lines.enableAssessment, lines.assessmentType, lines.valuesAssessment, lines.problemSolutionAssessment)
        }
        if (!hasReapplyPermission) {
          hiddenList.push(lines.canReapplyDays)
        }
        if (isEditMode) {
          disabledList.push(lines.resumeType, lines.enableAssessment, lines.assessmentType, lines.valuesAssessment, lines.problemSolutionAssessment)
        }

        _.filter([
          lines.resumeType,
          lines.enableAssessment,
          lines.assessmentType,
          lines.valuesAssessment,
          lines.problemSolutionAssessment,
          lines.candidateApplySatisfactionSurvey,
          lines.candidateInterviewSatisfactionSurvey,
          lines.hmInterviewSatisfactionSurvey,
          lines.hmGradeSatisfactionSurvey
        ], line => {
          return !hiddenList.includes(line) && !disabledList.includes(line)
        }).forEach(line => {
          Object.defineProperty(line, 'disabled', {
            configurable: true,
            enumerable: true,
            get () {
              return vm.isNotEditableJobTemplate
            }
          })
        })
      }
      _.forEach(hiddenList, line => {
        line.hidden = true
      })
      _.forEach(disabledList, line => {
        line.disabled = true
      })
      return lines
    }
  },
  created () {

  },
  methods: {
    getJobAssessmentStatus (val) {
      if (typeof val === 'string') {
        return val === '1'
      } else {
        return true
      }
    },
    getSatisfactionSurveyStatus (val) {
      if (typeof val === 'boolean') {
        return val
      } else {
        return true
      }
    },
    handleAssessmentStatusChange () {
      const stepData = this.stepData
      if (!stepData.valuesAssessment || !stepData.personalityAssessment) {
        stepData.careerPreferenceAssessment = false
      }
    },
    setStepDataToJobInfo () {
      const stepData = this.stepData
      const jobInfo = this.jobInfo
      this.$set(jobInfo, 'resume_type', stepData.resumeType)
      this.$set(jobInfo, 'required_resume_attachment', stepData.requiredResumeAttachment)
      this.$set(jobInfo, 'can_reapply_days', stepData.canReapplyDays)
      this.$set(jobInfo, 'problem_solving_required', stepData.problemSolutionAssessment ? '1' : '0')
      this.$set(jobInfo, 'enable_candidate_apply_satisfaction_survey', stepData.candidateApplySatisfactionSurvey)
      this.$set(jobInfo, 'enable_candidate_interview_satisfaction_survey', stepData.candidateInterviewSatisfactionSurvey)
      this.$set(jobInfo, 'enable_hm_interview_satisfaction_survey', stepData.hmInterviewSatisfactionSurvey)
      this.$set(jobInfo, 'enable_hm_grade_satisfaction_survey', stepData.hmGradeSatisfactionSurvey)
      if (this.canCustomAssessment) {
        this.$set(jobInfo, 'personality_required', stepData.enableAssessment ? '1' : '0')
        this.$set(jobInfo, 'personal_assessment_type', stepData.assessmentType || ASSESSMENT_TYPE.NORMAL)
        this.$set(jobInfo, 'assessment_value_required', stepData.valuesAssessment ? '1' : '0')
        this.$set(jobInfo, 'assessment_occupational_required', stepData.personalityAssessment ? '1' : '0')
        this.$set(jobInfo, 'assessment_additional_required', stepData.careerPreferenceAssessment ? '1' : '0')
      } else {
        this.$set(jobInfo, 'personality_required', stepData.valuesAssessment ? '1' : '0')
        this.$set(jobInfo, 'personal_assessment_type', stepData.assessmentType)
        if (stepData.valuesAssessment) {
          this.$set(jobInfo, 'assessment_value_required', '1')
          this.$set(jobInfo, 'assessment_occupational_required', '1')
          this.$set(jobInfo, 'assessment_additional_required', stepData.assessmentType === ASSESSMENT_TYPE.NORMAL ? '1' : '0')
        } else {
          this.$set(jobInfo, 'assessment_value_required', '0')
          this.$set(jobInfo, 'assessment_occupational_required', '0')
          this.$set(jobInfo, 'assessment_additional_required', '0')
        }
      }
    },
    async getStepData () {
      const jobInfo = this.jobInfo
      const stepData = {
        resumeType: jobInfo.resume_type || RESUME_TYPE.MINI,
        requiredResumeAttachment: jobInfo.required_resume_attachment || false,
        valuesAssessment: this.getJobAssessmentStatus(jobInfo.assessment_value_required),
        personalityAssessment: this.getJobAssessmentStatus(jobInfo.assessment_occupational_required),
        problemSolutionAssessment: this.getJobAssessmentStatus(jobInfo.problem_solving_required),
        careerPreferenceAssessment: this.getJobAssessmentStatus(jobInfo.assessment_additional_required),
        canReapplyDays: jobInfo.can_reapply_days,
        assessmentType: jobInfo.personal_assessment_type || ASSESSMENT_TYPE.NORMAL,
        get enableAssessment () {
          return this.valuesAssessment || this.personalityAssessment || this.problemSolutionAssessment || this.careerPreferenceAssessment
        },
        set enableAssessment (val) {
          this.valuesAssessment = this.personalityAssessment = this.problemSolutionAssessment = this.careerPreferenceAssessment = val
        },
        candidateApplySatisfactionSurvey: this.getSatisfactionSurveyStatus(jobInfo.enable_candidate_apply_satisfaction_survey),
        candidateInterviewSatisfactionSurvey: this.getSatisfactionSurveyStatus(jobInfo.enable_candidate_interview_satisfaction_survey),
        hmInterviewSatisfactionSurvey: this.getSatisfactionSurveyStatus(jobInfo.enable_hm_interview_satisfaction_survey),
        hmGradeSatisfactionSurvey: this.getSatisfactionSurveyStatus(jobInfo.enable_hm_grade_satisfaction_survey)
      }
      if (!this.canCustomAssessment) {
        stepData.personalityAssessment = false
        stepData.careerPreferenceAssessment = false
        stepData.valuesAssessment = this.getJobAssessmentStatus(jobInfo.personality_required)
        stepData.problemSolutionAssessment = this.getJobAssessmentStatus(jobInfo.problem_solving_required)
      }

      return stepData
    }
  }
}
</script>

<style lang="scss" scoped>
.job-application-config {
  .tip-icon {
    margin-left: 5px;
    font-size: 16px;
  }

  .assessment-detail {
    .assessment-checkbox {
      width: 100%;
      margin-right: 0;
    }
  }

  ::v-deep {
    .enable-radio {
      .el-radio-group {
        .el-radio {
          width: 101px;
        }
      }
    }

    .resume-type {
      margin-bottom: 0;
    }
  }
}

.resume-type-tip-container {
  .tip-title {
    margin-bottom: 5px;
  }

  .tip-content-list {
    margin-bottom: 5px;
    padding-left: 16px;
    list-style: disc;
  }

  .tip-mark {
    &::before {
      content: '*';
      margin-right: 5px;
      color: #f56c6c;
      font-size: 14px;
      vertical-align: middle;
    }
  }
}

.page-en {
  .job-application-config {
    ::v-deep {
      .resume-type {
        .el-radio-group {
          .el-radio {
            display: block;
            height: 32px;
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
